import { render, staticRenderFns } from "./memberUnitsDetails.vue?vue&type=template&id=5a600d83&scoped=true&"
import script from "./memberUnitsDetails.vue?vue&type=script&lang=js&"
export * from "./memberUnitsDetails.vue?vue&type=script&lang=js&"
import style0 from "./memberUnitsDetails.vue?vue&type=style&index=0&id=5a600d83&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a600d83",
  null
  
)

export default component.exports